import { ethers } from 'ethers'
import { logOT } from './loggingShared'
import { delay } from './fixtures'

export const advanceTimeInHours = async (providerJsonRpc: ethers.JsonRpcProvider, hours: number): Promise<Date> => {
  logOT.debug('advanceTimeInHours')
  const blockNumberB = await providerJsonRpc.getBlockNumber()
  const timestampStart = (await providerJsonRpc.getBlock(blockNumberB))?.timestamp ?? 0

  await providerJsonRpc.send('evm_mine', [])

  const increase = Math.round(hours * 3600)
  let currentIncrease = 0
  while (currentIncrease < increase + 10) {
    const step = Math.min(increase + 10 - currentIncrease, 3600)
    await providerJsonRpc.send('evm_increaseTime', [step])

    await providerJsonRpc.send('evm_mine', [])
    currentIncrease += step
  }
  // await providerJsonRpc.send('evm_increaseTime', [increase + 10])
  await providerJsonRpc.send('evm_mine', [])

  const blockEnd = await providerJsonRpc.getBlock('latest')

  let timestampNow = blockEnd?.timestamp ?? 0
  while (timestampNow < timestampStart + increase) {
    await delay(100)
    await providerJsonRpc.send('evm_mine', [])
    const blockEnd = await providerJsonRpc.getBlock('latest')
    //    logOT.info('wait')
    timestampNow = blockEnd?.timestamp ?? 0
  }

  const timestampEnd = (await providerJsonRpc.getBlock('latest'))?.timestamp ?? 0

  const newDate = new Date(timestampEnd * 1000)
  logOT.debug('Date to advance to ', timestampEnd, newDate, 'from  ', timestampStart, new Date(timestampStart * 1000))
  return newDate
}
